import { FormControl, FormGroup, Validators } from '@angular/forms';
import { User } from '@lib/api/models/user';

export interface CommissionerUser {
    id: string;
    commissioner_id: string;
    user_id: string;
    user: User;
    created_at: string;
    updated_at: string;
}

export interface CommissionerUserSingleResponse {
    data: CommissionerUser;
}

export interface StoreCommissionerUserRequest {
    id: string;
    position: string;
}

export function createCommissionerUserFormGroup(commissionerUser?: CommissionerUser) {
    return new FormGroup({
        position: new FormControl<string>(commissionerUser?.user.permissions?.permission_name ?? '', [
            Validators.required,
        ]),
    });
}
